module.exports = __webpack_public_path__ + "static/media/ehealth_pro_activiate_step_1.89f2bc40.png";